import { useRef, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PencilSimple, ArrowsClockwise, Trash, Check, X } from "@phosphor-icons/react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const msg = (e, f) => toast.error(e?.response?.data?.detail || f);

/** Umbenennen (Titel), Ersetzen (neue Version) und Löschen eines Dokuments. */
export function DocRowActions({ doc, onChanged }) {
  const [edit, setEdit] = useState(false);
  const [title, setTitle] = useState(doc.title || "");
  const [del, setDel] = useState(false);
  const file = useRef(null);
  const rename = async () => {
    try { await api.patch(`/documents/${doc.id}`, { title: title.trim() }); toast.success("Umbenannt"); setEdit(false); onChanged(); }
    catch (e) { msg(e, "Umbenennen fehlgeschlagen"); }
  };
  const replace = async (f) => {
    if (!f) return;
    const fd = new FormData(); fd.append("file", f);
    try { await api.post(`/documents/${doc.id}/new-version`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Datei ersetzt (neue Version)"); onChanged(); }
    catch (e) { msg(e, "Ersetzen fehlgeschlagen"); }
  };
  const remove = async () => {
    try { await api.delete(`/documents/${doc.id}`); toast.success("Dokument gelöscht"); onChanged(); }
    catch (e) { msg(e, "Löschen fehlgeschlagen"); }
  };
  if (edit) return (
    <div className="flex items-center gap-1 justify-end">
      <Input value={title} onChange={(e) => setTitle(e.target.value)} onKeyDown={(e) => e.key === "Enter" && title.trim() && rename()} className="h-7 text-xs w-56" autoFocus data-testid={`doc-rename-input-${doc.id}`} />
      <Button size="sm" variant="ghost" disabled={!title.trim()} onClick={rename} data-testid={`doc-rename-save-${doc.id}`}><Check size={14} /></Button>
      <Button size="sm" variant="ghost" onClick={() => setEdit(false)}><X size={14} /></Button>
    </div>
  );
  return (
    <>
      <input ref={file} type="file" className="hidden" onChange={(e) => { replace(e.target.files?.[0]); e.target.value = ""; }} />
      <Button size="sm" variant="ghost" onClick={() => { setTitle(doc.title || ""); setEdit(true); }} title="Umbenennen" data-testid={`doc-rename-${doc.id}`}><PencilSimple size={14} /></Button>
      <Button size="sm" variant="ghost" onClick={() => file.current?.click()} title="Datei ersetzen" data-testid={`doc-replace-${doc.id}`}><ArrowsClockwise size={14} /></Button>
      <Button size="sm" variant="ghost" onClick={() => setDel(true)} title="Löschen" className="text-rose-600 hover:text-rose-700" data-testid={`doc-delete-${doc.id}`}><Trash size={14} /></Button>
      <AlertDialog open={del} onOpenChange={setDel}>
        <AlertDialogContent>
          <AlertDialogHeader><AlertDialogTitle>Dokument löschen?</AlertDialogTitle>
            <AlertDialogDescription>„{doc.title}“ wird aus dem Mietverhältnis und der Dokumentenablage entfernt.</AlertDialogDescription></AlertDialogHeader>
          <AlertDialogFooter><AlertDialogCancel>Abbrechen</AlertDialogCancel>
            <AlertDialogAction onClick={remove} className="bg-rose-600 hover:bg-rose-700" data-testid={`doc-delete-confirm-${doc.id}`}>Löschen</AlertDialogAction></AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
